/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_change_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Because the goal is to measure the size of the move relative to where you started. Using the original value keeps the result comparable across different starting points — a $10 change means more on a $50 base (20%) than on a $500 base (2%), which the formula captures automatically.`)
};

const es_pct_change_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque el objetivo es medir el tamaño del movimiento en relación con el punto de partida. Usar el valor original mantiene el resultado comparable entre distintos puntos de partida — un cambio de $10 significa más sobre una base de $50 (20%) que sobre una base de $500 (2%), algo que la fórmula capta automáticamente.`)
};

const de_pct_change_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weil das Ziel darin besteht, die Größe der Veränderung relativ zum Ausgangspunkt zu messen. Der Ausgangswert sorgt dafür, dass das Ergebnis über verschiedene Ausgangspunkte hinweg vergleichbar bleibt — eine Veränderung von $10 bedeutet bei einer Basis von $50 mehr (20%) als bei einer Basis von $500 (2%), was die Formel automatisch berücksichtigt.`)
};

const nl_pct_change_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omdat het doel is de omvang van de verandering te meten ten opzichte van je startpunt. Door de oorspronkelijke waarde te gebruiken, blijft het resultaat vergelijkbaar tussen verschillende startpunten — een verandering van $10 betekent meer op een basis van $50 (20%) dan op een basis van $500 (2%), en dat vangt de formule automatisch.`)
};

const fr_pct_change_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parce que l’objectif est de mesurer l’ampleur du mouvement par rapport au point de départ. Utiliser la valeur d’origine permet de comparer les résultats entre différents points de départ — une variation de 10 $ compte davantage sur une base de 50 $ (20 %) que sur une base de 500 $ (2 %), ce que la formule capture automatiquement.`)
};

const it_pct_change_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché l'obiettivo è misurare l'entità del movimento rispetto al punto di partenza. Usare il valore originale rende il risultato confrontabile tra punti di partenza diversi — una variazione di $10 pesa di più su una base di $50 (20%) che su una base di $500 (2%), cosa che la formula cattura automaticamente.`)
};

const pt_br2_pct_change_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque o objetivo é medir o tamanho da mudança em relação ao ponto de partida. Usar o valor original mantém o resultado comparável entre pontos de partida diferentes — uma variação de $10 significa mais em uma base de $50 (20%) do que em uma base de $500 (2%), o que a fórmula capta automaticamente.`)
};

const pt_pct_change_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque o objetivo é medir a dimensão da variação em relação ao ponto de partida. Usar o valor original mantém o resultado comparável entre diferentes pontos de partida — uma variação de $10 significa mais numa base de $50 (20%) do que numa base de $500 (2%), o que a fórmula capta automaticamente.`)
};

const ja_pct_change_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目的が、開始地点に対する変化の大きさを測ることだからです。元の値を使うことで、異なる開始地点同士でも結果を比較できるようになります — 10ドルの変化は、500ドルの基準（2%）よりも50ドルの基準（20%）の方が大きな意味を持ちますが、この式はそれを自動的に反映します。`)
};

const zh_pct_change_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`因为目标是衡量变动幅度相对于起点的大小。以原始值为基准能让结果在不同起点之间保持可比性——同样是 $10 的变化，在 $50 的基数上（20%）比在 $500 的基数上（2%）意义更大，而公式会自动体现这一点。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_change_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_change_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_change_faq4_a", locale)
	if (locale === "en") return en_pct_change_faq4_a(inputs)
	if (locale === "es") return es_pct_change_faq4_a(inputs)
	if (locale === "de") return de_pct_change_faq4_a(inputs)
	if (locale === "nl") return nl_pct_change_faq4_a(inputs)
	if (locale === "fr") return fr_pct_change_faq4_a(inputs)
	if (locale === "it") return it_pct_change_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_pct_change_faq4_a(inputs)
	if (locale === "pt") return pt_pct_change_faq4_a(inputs)
	if (locale === "ja") return ja_pct_change_faq4_a(inputs)
	return zh_pct_change_faq4_a(inputs)
};